import { render, staticRenderFns } from "./OffrePlay.vue?vue&type=template&id=72aa20ba&lang=html"
import script from "./OffrePlay.vue?vue&type=script&lang=js"
export * from "./OffrePlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports